import { FieldPathByValue, FieldValues, Path, PathValue, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { countryLabelToCode } from "./CountryDropdown";
import { DEFAULT_COUNTRY_LABEL } from "./types";
import { AddressFields, GoogleAddress, placeToFormData } from "./placeToFormData";

export function countryCode<T extends FieldValues>(watch: UseFormWatch<T>, countryField?: Path<T>) {
  const country: string = countryField ? watch(countryField) : DEFAULT_COUNTRY_LABEL;
  return countryLabelToCode(country);
}

type StringPath<T extends FieldValues> = FieldPathByValue<T, string>;

export function setAddressFields<T extends FieldValues>(
  setValue: UseFormSetValue<T>,
  place: GoogleAddress,
  onSuggest?: (data: AddressFields) => void,
  mapField?: (f: keyof AddressFields) => StringPath<T>
) {
  const fields = placeToFormData(place);
  onSuggest?.(fields);

  let field: keyof AddressFields;
  for (field in fields) {
    let path = mapField?.(field) || (field as StringPath<T>);

    /**
     * FIXME: the need for this cast feels like a bug
     * @see https://github.com/react-hook-form/react-hook-form/issues/11966
     */
    let value = fields[field] as PathValue<T, StringPath<T>>;
    setValue(path, value, { shouldValidate: true });
  }
}
